<template>
  <div :class="['card shadow-md border', getBorderColor(status)]">
    <div class="card-body p-4">
      <div class="flex items-center justify-between mb-2">
        <h3 class="card-title text-base font-semibold">{{ resourceName }}</h3>
        <span :class="['badge badge-sm', getStatusClass(status)]">{{ status }}</span>
      </div>
      <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">{{ resourceType }}</p>
      <p class="text-sm text-gray-700 dark:text-gray-300 break-words">
        {{ description !== undefined && description !== null && description !== '' ? description : 'No details available.' }}
      </p>
       <p v-if="lastChecked !== null && lastChecked !== undefined" class="text-xs text-gray-400 dark:text-gray-500 mt-2">
          Last Checked: {{ formatTimestamp(lastChecked) }}
       </p>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  resourceName: {
    type: String,
    required: true,
  },
  resourceType: {
    type: String,
    required: true,
  },
  status: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  lastChecked: {
      type: String, 
      default: null
  }
});

function getStatusClass(status) {
  switch (status?.toUpperCase()) {
    case 'OK':
    case 'OPERATIONAL':
    case 'AVAILABLE':
      return 'badge-success';
    case 'ERROR':
    case 'DEGRADED':
    case 'UNAVAILABLE':
      return 'badge-error';
    case 'WARNING':
    case 'MAINTENANCE':
      return 'badge-warning';
    default: return 'badge-ghost'; 
  }
}

function getBorderColor(status) {
    switch (status?.toUpperCase()) {
    case 'OK':
    case 'OPERATIONAL':
    case 'AVAILABLE':
      return 'border-success';
    case 'ERROR':
    case 'DEGRADED':
    case 'UNAVAILABLE':
      return 'border-error';
    case 'WARNING':
    case 'MAINTENANCE':
      return 'border-warning';
    default: return 'border-base-300'; 
  }
}

function formatTimestamp(dateString) {
  if (dateString === null || dateString === undefined) return 'N/A';
  try {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat(navigator.language !== undefined && navigator.language !== null && navigator.language !== '' ? navigator.language : 'en-US', {
      dateStyle: 'short', timeStyle: 'medium'
    }).format(date);
  } catch (error) { return dateString; }
}
</script>

<style scoped>
.badge { color: white; }
.badge-error { background-color: #f87171; border-color: #f87171; }
.badge-success { background-color: #34d399; border-color: #34d399; }
.badge-warning { background-color: #fbbf24; border-color: #fbbf24; color: #374151;}
.badge-info { background-color: #60a5fa; border-color: #60a5fa; }
.badge-ghost { background-color: #e5e7eb; border-color: #e5e7eb; color: #374151; }

.border-success { border-color: #34d399; }
.border-error { border-color: #f87171; }
.border-warning { border-color: #fbbf24; }
</style> 